var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurLoc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6299 0C12.4732 0 12.313 0.0300781 12.1544 0.09625L0.785681 5.34324C-0.525998 5.95547 -0.0887716 7.87938 1.31041 7.87938H6.12045V12.6894C6.12045 13.51 6.78244 14 7.45318 14C7.92623 14 8.40338 13.7566 8.65658 13.2141L13.9038 1.84516C14.2749 0.954024 13.5115 0 12.6299 0ZM7.43213 12.6894V6.5677H6.12045L1.32217 6.58711C1.31478 6.57699 1.30931 6.5502 1.33529 6.53434L12.634 1.31961C12.6507 1.33082 12.669 1.34887 12.6802 1.36555L7.43213 12.6894Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurLoc);
export default __webpack_public_path__ + "static/media/cur-loc.5c7dda6c364b9fb8125d8f7662083e9b.svg";
export { ForwardRef as ReactComponent };